<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">RECAUDOS {{ person.nombre }}</div>
    <div class="box-container">
      <div class="box-filtres">
        <table width="100%">
          <tbody>
            <tr>
              <td width="250px">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div>Agregar Nueva Placa</div>
                        <input
                          type="text"
                          class="form-control"
                          autocomplete="off"
                          v-model="placa"
                          style="text-transform: uppercase"
                          v-on:keypress="GLOBAL.SOLO_ALFANUMERICOS"
                          @keyup.enter="getVehiculosPorPlaca"
                        />
                      </td>
                      <td style="vertical-align: bottom">
                        <button
                          class="btn btn-warning"
                          @click="getVehiculosPorPlaca"
                        >
                          <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td width="40px" style="vertical-align: bottom; padding: 7px">
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <td colspan="3">
                <hr />
                <div
                  style="
                    height: 100px;
                    background-color: #e6e6e6;
                    padding: 10px;
                  "
                >
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <div>PLACA</div>
                          <div>
                            <input
                              type="text"
                              v-model="acuerdo.vehiculo_placa"
                              class="form-control"
                              style="text-transform: uppercase; width: 200px"
                              v-on:keypress="GLOBAL.SOLO_ALFANUMERICOS"
                              readonly
                            />
                          </div>
                        </td>
                        <td>
                          <div>CODIGO DE ACUERDO</div>
                          <div>
                            <input
                              type="text"
                              v-model="acuerdo.acuerdo_codigo"
                              class="form-control"
                              style="text-transform: uppercase; width: 200px"
                              v-on:keypress="GLOBAL.SOLO_ALFANUMERICOS"
                              autocomplete="nope"
                            />
                          </div>
                        </td>
                        <td>
                          <div>FECHA DE ACUERDO</div>
                          <div>
                            <input
                              type="text"
                              datatype="fecha"
                              v-model="acuerdo.acuerdo_fecha"
                              @change="
                                actualizaComponente(acuerdo.acuerdo_fecha)
                              "
                              id="acuerdo_fecha"
                              autocomplete="nope"
                              class="form-control"
                              style="width: 160px"
                            />
                          </div>
                        </td>
                        <td>
                          <div>VALOR</div>
                          <div>
                            <input
                              type="text"
                              v-model="acuerdo.acuerdo_valor"
                              class="form-control"
                              style="width: 100px"
                              v-on:keypress="GLOBAL.SOLO_DECIMALES"
                              autocomplete="nope"
                            />
                          </div>
                        </td>
                        <td>
                          <div>ESTADO</div>
                          <div>
                            <select
                              class="form-control"
                              style="width: 110px"
                              v-model="acuerdo.acuerdo_estado"
                            >
                              <option value="A">ACTIVO</option>
                              <option value="I">INACTIVO</option>
                            </select>
                          </div>
                        </td>
                        <td style="vertical-align: bottom">
                          <button class="btn btn-info" @click="guardarAcuerdo">
                            <i class="fa-solid fa-save"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div style="height: 30px; padding: 10px; color: red">
                  {{ mensaje }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <DataTable
          :columns="columns"
          :data="reporte"
          :options="options"
          class="display nowrap"
          style="width: 100%"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import VehiculoService from "../Vehiculos/VehiculoService.js";

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net";
import Buttons from "datatables.net-buttons";
import ButtonsHtml5 from "datatables.net-buttons/js/buttons.html5";

DataTable.use(DataTablesCore);
DataTable.use(Buttons);
DataTable.use(ButtonsHtml5);

export default {
  components: {
    DataTable,
  },
  data() {
    return {
      GLOBAL,
      columns: [
        { title: "Acuerdo", data: "acuerdo_codigo" },
        { title: "Placa", data: "vehiculo_placa" },
        { title: "Fecha", data: "acuerdo_fecha" },
        { title: "Acuerdo tipo", data: "acuerdo_tipo" },
        {
          title: "Valor",
          data: "acuerdo_valor",
          className: "text-right",
          render: function (data, type, row) {
            return GLOBAL.FORMATO_MONEY_BASIC(row.acuerdo_valor);
          },
        },
        {
          title: "Estado",
          data: "acuerdo_estado",
          className: "text-center",
          render: (data) => (data === "A" ? "ACTIVO" : "INACTIVO"),
        },
        { title: "Acciones", class: "text-right", render: (data) => "" },
      ],
      options: {
        ...GLOBAL.TABLE_OPTIONS,
        createdRow: function (row, data, dataIndex) {
          const vueInstance = this; // Almacena una referencia a 'this'
          var deleteBtn = $(
            "<button class='btn btn-sm btn-info'><i class='fa-solid fa-pencil'></i></button>"
          );
          $(deleteBtn).on("click", function () {
            vueInstance.openMe(data); // Usa la referencia correcta a 'this'
          });
          $("td", row).eq(6).append(deleteBtn);
        }.bind(this), // Asegura que 'this' se refiera al componente Vue
      },
      reporte: [],
      person: null,
      vehiculo: null,
      tercero: null,
      placa: "",
      loading: false,
      conversion: null,
      disableBotonGuardar: true,
      mensaje: "",
      acuerdo: null,
    };
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );

    this.reporteService = new VehiculoService();

    this.resetDatosVehiculos();

    this.mensaje = "";
  },
  mounted() {
    $("input[datatype='fecha']").datepicker({
      onSelect: (dateText) => {
        this.actualizaComponente(dateText);
      },
    });
    this.getReporteEquipos();
  },
  methods: {
    actualizaComponente(selected) {
      this.acuerdo.acuerdo_fecha = selected;
    },

    guardarAcuerdo() {
      var validacion = "OK";

      this.acuerdo.acuerdo_fecha = $("#acuerdo_fecha").val();

      if (this.acuerdo.acuerdo_fecha.trim() == "") {
        validacion = "Verifique la fecha";
      }

      if (this.acuerdo.acuerdo_codigo.trim() != "") {
        this.acuerdo.acuerdo_codigo = this.acuerdo.acuerdo_codigo.toUpperCase();
      }

      if (this.acuerdo.vehiculo_id == 0) {
        validacion = "Se requiere un vehículo";
      }

      if (this.vehiculo.vehiculo_id == 0) {
        validacion = "Se requiere un vehículo";
      } else {
        this.acuerdo.vehiculo_id = this.vehiculo._id;
      }

      if (this.acuerdo.acuerdo_valor < 0) {
        validacion = "Se verifique el valor";
      }

      if (validacion == "OK") {
        this.mensaje = "";
        this.disableBotonGuardar = false;

        console.log(this.acuerdo);

        if (this.acuerdo.uniqueid != "") {
          this.loading = true;
          this.reporteService
            .actualizarAcuerdo(this.person, this.acuerdo)
            .then((data) => {
              if (data.status == 200) {
                this.resetDatosVehiculos();
                this.getReporteEquipos();
              } else {
                if (typeof data.data != "undefined") {
                  this.mensaje = data.data;
                } else {
                  this.mensaje = "No fue posible realizar la operación";
                }
              }
              this.loading = false;
            })
            .then(() => {});
        } else {
          this.loading = true;
          this.reporteService
            .crearAcuerdo(this.person, this.acuerdo)
            .then((data) => {
              if (data.status == 200) {
                this.resetDatosVehiculos();
                this.getReporteEquipos();
              } else {
                if (typeof data.data != "undefined") {
                  this.mensaje = data.data;
                } else {
                  this.mensaje = "No fue posible realizar la operación";
                }
              }
              this.loading = false;
            })
            .then(() => {});
        }
      } else {
        this.mensaje = validacion;
      }
    },

    resetDatosVehiculos() {
      this.vehiculo = {};
      this.vehiculo._id = 0;
      this.vehiculo.placa = "";

      this.acuerdo = {};
      this.acuerdo.uniqueid = "";
    },

    getVehiculosPorPlaca() {
      this.loading = true;
      var identificacion = btoa(GLOBAL.SECRET_KEY + btoa(this.placa));
      console.log(identificacion);
      this.reporteService
        .getVehiculosPorPlaca(this.person, identificacion)
        .then((data) => {
          console.log(data);
          if (data.status == 200) {
            this.placa = "";
            this.vehiculo = data.data;
            this.acuerdo.vehiculo_id = this.vehiculo._id;
            this.acuerdo.vehiculo_placa = this.vehiculo.placa;
            this.mensaje = "";

            if (this.vehiculo.acuerdo_id != 0) {
              this.mensaje = "Este vehiculo ya posee un acuerdo";
            }
          } else {
            this.resetDatosVehiculos();
            this.mensaje = "Vehículo no fue encontrado";
          }
          this.loading = false;
        });
    },

    openMe(item) {
      this.acuerdo = item;
      console.log(item);

      this.vehiculo = {};
      this.vehiculo._id = item.vehiculo_id;
      this.vehiculo.placa = item.vehiculo_placa;

      this.mensaje = "";
      $("#myModal").modal("show");
    },

    getReporteEquipos() {
      this.reporte = [];
      this.loading = true;
      this.reporteService.getListaAcuerdos(this.person).then((response) => {
        this.reporte = response.data;
        this.loading = false;
      });
    },
  },
};
</script>
